import React from "react";
import { FormContext } from "./FormContext";

export default class Textarea extends React.Component {
	static contextType = FormContext;

	static id = 1;

	constructor(props) {
		super(props);
		this.state = {
			value: typeof props.value == 'undefined' ? '' : this.props.value,
			error: false
		};

		this.handleChange = this.handleChange.bind(this);
		this.setValue = this.setValue.bind(this);
		this.setError = this.setError.bind(this);
		this.htmlId = "t" + Textarea.id++;
	}

	setValue(value) {
		this.setState({ value: value });
	}

	setError(error) {
		this.setState({ error: error });
	}

	handleChange(e) {
		let value = e.target.value;
		this.setState({ value: value });
		this.context.setValue(this.props.name, value);
	}

	componentDidMount() {
		this.context.initInput(this.props.name, typeof this.props.value == 'undefined' ? '' : this.props.value, this.setValue, this.setError);
	}

	render() {
		return (
			<div className={"form-group-textarea mb-1" + (this.props.required && !this.state.value ? ' required' : '')}>
				{this.props.label && <label className="form-label" htmlFor={this.htmlId}>{this.props.label}</label>}
				<div className="form-control-wrap">
					<textarea value={this.state.value || ''} required={this.props.required} onChange={this.handleChange} disabled={this.context.readOnly || this.props.readOnly} maxLength={this.props.maxLength} className={"form-control" + (this.state.error ? " error" : '')} id={this.htmlId} />
					{this.state.error && <span className="invalid">{this.state.error}</span>}
				</div>
			</div>
		);
	}
}